import apiClient from '../middleware/apiClient';
import { getIsXapExit } from '../helpers/xap';
import { p2pProps } from '../helpers/p2p';
import { getIsToday } from '../helpers/date';
import { dispatchSendTransaction } from './adobe';
import { COTTON_PAYMENT_PLAN_SIGNUP } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

import {
  PAYMENT_PLAN_SIGNUP,
} from '../helpers/apis';
import { getBillDataPastDueBalance } from '../helpers/billData';

// post payment plan
export const POST_PAYMENT_PLAN = 'POST_PAYMENT_PLAN';
export const POST_PAYMENT_PLAN_SUCCESS = 'POST_PAYMENT_PLAN_SUCCESS';

function dispatchPostPaymentPlan(data, isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_PAYMENT_PLAN_SIGNUP : PAYMENT_PLAN_SIGNUP;
  return {
    type: POST_PAYMENT_PLAN,
    payload: apiClient.fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  };
}

function dispatchPostPaymentPlanSuccess(payload) {
  return {
    type: POST_PAYMENT_PLAN_SUCCESS,
    payload,
  };
}

// Just up to a year?
const numberMap = [
  'zero', 'one', 'two', 'three', 'four',
  'five', 'six', 'seven', 'eight', 'nine',
  'ten', 'eleven', 'twelve',
];

export const exitXapIfEligible = ({
  useBillData = false,
  useContextHub = false,
} = {}) => async (dispatch, getState) => {
  const {
    account: { account: legacyAccount } = {},
    contextHub: { contextHub } = {},
    payment: { review, review: { amount, date } = {} } = {},
    bill: { bill, bill: { summary: { pastDueBalanceRemaining } = {} } = {} } = {},
    billData: { billData } = {},
    arrangement: { arrangement } = {},
    paymentPlan: {
      review: { installmentPlan: plan, billDueDate } = {},
    } = {},
  } = getState();
  const account = useContextHub ? contextHub : legacyAccount;
  const pastDueBalance = useBillData
    ? getBillDataPastDueBalance(billData)
    : pastDueBalanceRemaining;
  const payInfull = !!(
    (amount && parseFloat(amount) >= pastDueBalance)
    && (!date || getIsToday(date))
  );
  const installmentPlan = payInfull ? undefined : plan;
  const { isP2P, qualifies } = p2pProps({
    account, bill, billData, review, useBillData, arrangement, useArrangementApi: useBillData,
  });
  const p2p = !installmentPlan && !payInfull && !!isP2P && !!qualifies;
  const eligibleForPlan = getIsXapExit(account) || account?.xap.ltip === 'ELIGIBLE';
  if (eligibleForPlan && (payInfull || p2p || installmentPlan)) {
    const payload = {
      installmentPlan,
      payInfull,
      p2p,
    };
    const isCottonSession = getCottonSession();

    // no try catch because we should always return success
    await dispatch(
      dispatchPostPaymentPlan(payload, isCottonSession),
    ).payload.catch(() => Promise.resolve());

    // Send an SST regarding the mode of XAP exit, if it's via installment.
    if (installmentPlan) {
      const { numberOfPayments } = installmentPlan;
      dispatch(dispatchSendTransaction({
        name: 'self service transaction',
        action: 'self service transaction',
        transaction: `billing:xap installment:${numberMap[numberOfPayments]} months:signup`,
      }));
    }

    return dispatch(dispatchPostPaymentPlanSuccess({
      installmentPlan,
      billDueDate,
    }));
  }
  return null;
};
